import React from 'react';
import { SectionProps } from 'contracts/section';
import * as S from './styles';

const Section: React.FC<SectionProps> = ({
  position,
  image,
  title,
  text,
  legend,
}) => {
  return (
    <S.Container position={position}>
      <S.Content position={position}>
        <S.Photo
          src={image}
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        />
      </S.Content>
      <S.Content className="text" position={position}>
        <S.Wrapper
          position={position}
          className="wow animate__animated animate__fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        >
          <S.Title>{title}</S.Title>
          <S.Text>{text}</S.Text>
          <S.Legend>{legend}</S.Legend>
        </S.Wrapper>
      </S.Content>
    </S.Container>
  );
};

export default Section;
